/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'rbac-module';
const componentName = 'role-filter-match-label';
const prefix = `${moduleName}.${componentName}`;

export const keyAndValuesHeader = `${prefix}.keyAndValuesHeader`;

export const ENGLISH = {
    [keyAndValuesHeader]: 'Key & Values ({0})',
};
